import { useCallback, useEffect, useState } from 'react';

import { EmblaCarouselType } from 'embla-carousel';

type UseSliderButtonsType = {
  isPrevBtnDisabled: boolean;
  isNextBtnDisabled: boolean;
  onPrevButtonClick: VoidFunction;
  onNextButtonClick: VoidFunction;
};

export const useSliderButtons = (emblaApi: EmblaCarouselType | undefined): UseSliderButtonsType => {
  const [isPrevBtnDisabled, setIsPrevBtnDisabled] = useState(true);
  const [isNextBtnDisabled, setIsNextBtnDisabled] = useState(true);

  const onPrevButtonClick = useCallback(() => {
    if (!emblaApi) return;
    emblaApi.scrollPrev();
  }, [emblaApi]);

  const onNextButtonClick = useCallback(() => {
    if (!emblaApi) return;
    emblaApi.scrollNext();
  }, [emblaApi]);

  const onSelect = useCallback((emblaApi: EmblaCarouselType) => {
    setIsPrevBtnDisabled(!emblaApi.canScrollPrev());
    setIsNextBtnDisabled(!emblaApi.canScrollNext());
  }, []);

  useEffect(() => {
    if (!emblaApi) return;

    onSelect(emblaApi);
    emblaApi.on('reInit', onSelect).on('select', onSelect);
  }, [emblaApi, onSelect]);

  return {
    isPrevBtnDisabled,
    isNextBtnDisabled,
    onPrevButtonClick,
    onNextButtonClick,
  };
};
